/**
 * 企业认证管理
 */
import ApiPort from '../config/api-port'
import GlobalConfig from '../config/global'
import {handleError, handleResponse, handleResponseAssignObj} from "../lib/common";
import {dealElement} from "../lib/common";
import HttpAxios from "./http-axios";

const junziqianApi = GlobalConfig.domain.junziqianApi

export default {
  /**
   * 企业信息更新
   * @param businessLicenseImg 营业执照扫件件/3证合一扫描件 file
   * @param taxCertificateImg 税务登记证 file
   * @param frontLegalIdentityCard 法人身份证正面 file
   * @param versonLegalIdentityCard 法人身份证反面 file
   * @param frontAgentAdentityCard 委托人身份证正面 file
   * @param versonAgentIdentityCard 委托人身份证反面 file
   * @param agentAttorneyCard  授权委托书 file
   * @param applyTableImg  申请表扫描件 file
   * @param enterpriseLogoPath  企业LOGO file
   * @param workedImg  企业签章 file
   * @param userId  用户Id
   * @param name  用户名称
   * @param sourceName  来源名称
   * @param linkman  联系人
   * @param mobilePhone  企业联系人手机
   * @param businessLicense  营业执照注册号
   * @param enterpriseIntroduce  企业介绍
   * @param organizationCode  组织机构代码
   * @param legalName  法人姓名
   * @param legalCard  法人身份证号
   * @param legalMobilePhone  法人手机号
   * @returns {Promise<T>}
   */
  updateEntAuthInfo({businessLicenseImg, taxCertificateImg, frontLegalIdentityCard,
                                      versonLegalIdentityCard, frontAgentIdentityCard, versonAgentIdentityCard, agentAttorneyCard,
                                      applyTableImg, enterpriseLogoPath, workedImg, userId, name, sourceName, linkman, mobilePhone,
                                      businessLicense, enterpriseIntroduce, organizationCode, legalName, legalCard, legalMobilePhone}) {
    let url = junziqianApi + ApiPort.entAuthController.updateInfo
    let jsonData = {businessLicenseImg: businessLicenseImg, taxCertificateImg: taxCertificateImg, frontLegalIdentityCard: frontLegalIdentityCard,
      versonLegalIdentityCard: versonLegalIdentityCard, frontAgentIdentityCard: frontAgentIdentityCard, versonAgentIdentityCard: versonAgentIdentityCard,
      agentAttorneyCard: agentAttorneyCard, applyTableImg: applyTableImg, enterpriseLogoPath: enterpriseLogoPath, workedImg: workedImg,
      userId: userId, name: name, sourceName: sourceName, linkman: linkman, mobilePhone: mobilePhone, businessLicense: businessLicense,
      enterpriseIntroduce: enterpriseIntroduce, organizationCode: organizationCode, legalName: legalName, legalCard: legalCard, legalMobilePhone: legalMobilePhone}
    let formData = new FormData()
    jsonData = dealElement(jsonData)

    for (let key in jsonData) {
      formData.append(key, jsonData[key])
    }

    return HttpAxios.postForm(url, formData)
      .then(handleResponse)
      .catch(handleError)
  },

  /**
   * 企业详情查看，图片信息通过 文件操作show展示
   * @param userId 用户Id
   * @returns {Promise<T>}
   */
  postFindEntAuthByUserId(userId) {
    let url = junziqianApi + ApiPort.entAuthController.findByUserId
    let jsonData = {userId: userId}
    let dataInfo = {agentAttorneyCard: "", applyTableImg: "", businessLicense: "", businessLicenseImg: "", createTime: "", email: "",
      enterpriseIntroduce: "", enterpriseLogoPath: "", enterpriseUserEsignature: "", frontAgentIdentityCard: "", frontLegalIdentityCard: "",
      legalCard: "", legalMobilePhone: "", legalName: "", linkman: "", mobilePhone: "", name: "", organizationCode: "", sourceName: "",
      status: "", taxCertificateImg: "", userId: "", versonAgentIdentityCard: "", versonLegalIdentityCard: "", workedImg: "" }

    return HttpAxios.post(url, jsonData)
      .then(response => {
        let data = response.data

        if (data.success === true || data.success === 'true') {
          data.data = Object.assign(dataInfo, data.data)

          return Promise.resolve(data)
        } else {
          return Promise.reject(data)
        }
      })
      .catch(handleError)
  },

  /**
   * 企业认证管理列表
   * @param itemPage 页数
   * @param pageSize 页长
   * @param column 列属性 name企业名称 email企业邮箱 business_license证件号
   * @param value 值
   * @param beginDate 开始时间 yyyy-MM-dd
   * @param endDate 结束时间 yyyy-MM-dd
   * @param status状态 -1，未申请 0，待审核 1，审核通过 2，审核未通过
   * @returns {*|PromiseLike<T>|Promise<T>}
   */
  postEntAuthFindByPage({itemPage, pageSize, column, value, beginDate, endDate, status}) {
    let url = junziqianApi + ApiPort.entAuthController.findByPage
    let  jsonData = {itemPage: itemPage, pageSize: pageSize, column: column, value: value, beginDate: beginDate, endDate: endDate, status: status}
    let listInfo =   {agentAttorneyCard: "", applyTableImg: "", businessLicense: "", businessLicenseImg: "", createTime: "", email: "",
      enterpriseIntroduce: "", enterpriseLogoPath: "", enterpriseUserEsignature: "", frontAgentIdentityCard: "", frontLegalIdentityCard: "",
      legalCard: "", legalMobilePhone: "", legalName: "", linkman: "", mobilePhone: "", name: "", organizationCode: "", sourceName: "",
      status: "", taxCertificateImg: "", userId: "", versonAgentIdentityCard: "", versonLegalIdentityCard: "", workedImg: ""}

    jsonData = dealElement(jsonData)

    return HttpAxios.post(url, jsonData)
      .then(res => handleResponseAssignObj(res, listInfo))
      .catch(handleError)
  }
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/entAuthController.js